import React from "react";

const Aboutme = () => {
  return (
    <section id="aboutme" className="p-4">
      <h1 className="glow text-center p-5">ABOUT ME</h1>
      <p className="h4 text-light text-center">
        I'm a Full Stack Web Developer with an interest in Frontend. I recently
        graduated from the Northwestern University full stack web development
        program. Curious, determined, and creative always pushing myself to new
        ambitious heights. When I'm not coding my other passions include
        reading, video games, and Movies.
      </p>
    </section>
  );
};

export default Aboutme;
